import { createSelector } from 'reselect';

export const getListing = (state) => state.listing;
export const getCheckedItemsOnTable = (state) => state.listing.checkboxSelections;
export const getFilteredDataOnTable = (state) => state.listing.filteredData;
export const getClickedRowOnTable = (state) => state.listing.clickedRow;
export const getRefresh = (state, tableID) => state.listing[tableID].refresh;
export const getCheckedItemIds = createSelector(
  getCheckedItemsOnTable,
  (items) => items.map((item) => item.id),
);
